import { ITask } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { inboxActions } from '../state';
import SoftPhoneModule from '@modules/SoftPhoneModule';

function handleTaskUnhold(_context: InboxContext, task: ITask): void {
  inboxActions.setSelectedTaskId(task.id);
  SoftPhoneModule.callControl.unhold(task.attributes.callId);
}

export default handleTaskUnhold;
